/**
 * Register the Flexi-location service worker.
 * - Skipped automatically on localhost dev (CRA hot reload conflicts).
 * - Registers `/service-worker.js` in production builds.
 * - Auto-reloads the page once when a fresh SW takes control so users
 *   never see a stale white screen after a redeploy.
 */
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  // Skip on dev server (port 3000 webpack-dev-server) — SW would cache the dev bundle.
  const isLocalhost = ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);
  if (isLocalhost && process.env.NODE_ENV !== 'production') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => {
        // If a waiting worker is already there, ask it to take over now.
        if (reg.waiting) reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        reg.addEventListener('updatefound', () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              // A new SW is ready and an old one was controlling: ask it to skip waiting.
              sw.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => {
        /* silently ignore — SW is progressive enhancement */
      });

    // When a new SW takes control, reload once so the user sees the new bundle.
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
